// src/ColorsPage.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import './css/ColorsPage.css';
import '../styles/burger-menu.css';
import BackgroundColor from '../components/BackgroundColor';
import DiskPreview from '../components/DiskPreview';
import NextButton from '../components/NextButton';
import RouteGuard from '../components/RouteGuard';
import { useImageContext } from '../contexts/ImageContext';
import defaultSpinningDisk from '../images/defaultSpinningDisk.jpg';
import useScrollDirection from '../hooks/useScrollDirection';

function ColorsPage() {
  const { scrollDirection, isAtTop } = useScrollDirection();
  const { uploadedImage, imageName } = useImageContext();
  
  // Check if a real image has been uploaded (not the default)
  const hasUploadedImage = uploadedImage && 
    (uploadedImage !== defaultSpinningDisk && 
     !uploadedImage.includes('defaultSpinningDisk') &&
     (uploadedImage.startsWith('data:') || imageName !== 'example.jpg'));
  
  const handleMenuToggle = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    window.dispatchEvent(new CustomEvent('toggleNavigationMenu'));
  };

  return (
    <RouteGuard requiresImage={true} redirectTo="/images">
      <div className="colors-page">
        <div className="colors-container">
          <div className='colors-content'>
            <div className='colors-left-column'>
              <div className='color-options-container'>
                <div className="page-header-with-menu">
                  <button
                    className={`page-header-menu-button ${scrollDirection === 'down' && !isAtTop ? 'hide-on-scroll' : ''}`}
                    onClick={handleMenuToggle}
                    onTouchEnd={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleMenuToggle(e);
                    }}
                    type="button"
                    aria-label="Open menu"
                  >
                    <FontAwesomeIcon icon={faBars} />
                  </button>
                  <h2 className="page-title-mobile">Colour</h2>
                  <h2 className="page-title-desktop">Colour</h2>
                </div>
                <p className="page-description">
                  Choose a background colour or pick from suggestions based on your artwork.
                </p>
                <BackgroundColor
                />
              </div>
            </div>
            <div className='colors-right-column'>
              <DiskPreview className='colors-page-disk-display'/>
            </div>
          </div>
          <div className="page-navigation">
            <NextButton 
              nextPath="/audio" 
              disabled={!hasUploadedImage}
              text="Add Audio"
            />
          </div>
        </div>
      </div>
    </RouteGuard>
  );
}

export default ColorsPage;
